var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['avatar', _vm.size, _vm.color, { hasImage: _vm.img }]},[(!_vm.img)?_vm._t("default"):_c('img',{class:['avatar', _vm.size, _vm.color],style:(_vm.imageStyle),attrs:{"src":_vm.img}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }